import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchDeleteFirestopLabel } from '../services/patch-delete-firestop-label.service';

export const deleteFirestopLabel = createAsyncThunk(
  'firestopDocumentation/deleteFirestopLabel',
  async (labelId, { getState, rejectWithValue }) => {
    const projectId = selectSelectedProjectId(getState());

    try {
      const response = await patchDeleteFirestopLabel(projectId, labelId);

      return { labelId, ...response };
    } catch (error) {
      return rejectWithValue(error?.message || 'Label deletion failed');
    }
  }
);
